const checklisttemplatecategory = {
	module: "Equipment Checklist",
	list_title: "Equipment Checklists",
	new_title: "New Equipment Checklist",
	edit_title: "Edit Equipment Checklist",
	type: "Checklist Type",
	category: "Category",
	name: "Name",
};
export default checklisttemplatecategory;